<template>

  <div>
    <div v-if="investmentUpcomingPayments.count !== 0">
      <div class="horizontal-responsive">
        <table class="table-investment">
          <tr>
            <th>Fecha</th>
            <th>Cantidad</th>
            <th>Comentarios</th>
          </tr>
          <tr
            v-for="value in investmentUpcomingPayments.results"
            :key="value.id">
            <td>{{ value.date }}</td>
            <td>{{ formatCurrency( Number(value.amount)) }}</td>
            <td v-html="value.observations"></td>
          </tr>
        </table>
        <p class="-centered-info">
          <small>{{ currentPage }} de {{ totalPages }}</small>
        </p>
      </div>
      <div class="table-pagination -centered-info">
        <button
          class="button button-small"
          @click="paginationTable(investmentUpcomingPayments.previous, 'previous')"
          :disabled="investmentUpcomingPayments.previous === null">
          Anterior
        </button>
        <button
          class="button button-small"
          @click="paginationTable(investmentUpcomingPayments.next)"
          :disabled="investmentUpcomingPayments.next === null">Siguiente
        </button>
      </div>
    </div>
    <div v-else>
      <p>Aún no hay fechas compromiso para este id.</p>
    </div>
  </div>

</template>

<script>
import mixins from '@/mixins/index'

export default {
  name: 'UpcomingPayments',
  mixins: [mixins],
  props: {
    investmentUpcomingPayments: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      totalPages: 1,
      currentPage: 1
    }
  },
  created: function () {
    if (this.investmentUpcomingPayments.count >= 10) {
      this.totalPages = Math.round(this.investmentUpcomingPayments.count / 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboardInvestment/UpcomingPayments.vue